import { createImpersonationSession } from '@opendoor/auth-fe/impersonation-state';

import { supportNavigationHref } from './supportImpersonation';

export const impersonationSession = createImpersonationSession();

export const CUSTOMER_ACTION_BLOCKED_MESSAGE = 'This action isn’t available while impersonating.';

export class CustomerActionBlockedError extends Error {
  constructor(message = CUSTOMER_ACTION_BLOCKED_MESSAGE) {
    super(message);
    this.name = 'CustomerActionBlockedError';
  }
}

export const refuseCustomerAction = (operationName: string): never => {
  impersonationSession.refuseWrite(operationName);
  throw new CustomerActionBlockedError();
};

export const assertCustomerTransportAvailable = (operationName: string): void => {
  if (impersonationSession.isImpersonatingSession()) refuseCustomerAction(operationName);
};

export const getCustomerNavigationHref = (href: string): string => {
  const customerUUID = impersonationSession.getImpersonatedCustomer();
  if (!customerUUID || typeof window === 'undefined') return href;
  return supportNavigationHref({ href, currentUrl: window.location.href, customerUUID });
};

export const fetchCustomerAction: typeof fetch = (input, init): Promise<Response> => {
  if (typeof window === 'undefined' || !impersonationSession.isImpersonatingSession()) {
    return fetch(input, init);
  }
  const method = (init?.method ?? (input instanceof Request ? input.method : 'GET')).toUpperCase();
  if (method === 'GET' || method === 'HEAD' || method === 'OPTIONS') return fetch(input, init);

  const rawUrl = typeof input === 'string' || input instanceof URL ? input : input.url;
  let operationName = method;
  try {
    operationName = `${method} ${new URL(rawUrl, window.location.href).pathname}`;
  } catch {
    // The method remains a safe label when a caller supplies an invalid URL.
  }
  return refuseCustomerAction(operationName);
};
